<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-dialog scrollable v-model="dialogs.add" max-width="500px" persistent>
      <material-card
        :title="$t('views.planbalance.add_payment_{0}', [name])"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form style="margin:20px" ref="form" v-model="valid">
            <v-row>
              <v-col xs="12" sm="6">
                <no-autocomplete-textfield
                  v-model="payment.ChequeNumber"
                  :label="$t('views.planbalance.cheque_number')"
                ></no-autocomplete-textfield>
              </v-col>
              <v-col xs="12" sm="6">
                <pbas-date-picker
                  :value="payment.ChequeDate"
                  @update-date="payment.ChequeDate = $event"
                  :label="$t('headers.selfpayments.payment_date')"
                  :rules="[$rules.required]"
                  class="required"
                ></pbas-date-picker>
              </v-col>
              <v-col xs="12" sm="6">
                <trans-select2
                  v-model="payment"
                  propertyName="BillingTerm"
                  :items="billingTerms"
                  :label="$t('views.planbalance.billing_term')"
                  :rules="[$rules.required]"
                  field="Name"
                  itemValue="Id"
                  class="required"
                ></trans-select2>
              </v-col>
              <v-col xs="12" sm="6">
                <currency-textfield
                  v-model="payment.Amount"
                  :label="$t('globals.amount')"
                  class="required"
                  :rules="[$rules.requiredNum]"
                />
                <!-- <no-autocomplete-textfield
                  v-model="payment.Amount"
                  :label="$t('globals.amount')"
                  :rules="[$rules.required]"
                  prefix="$"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp"
                  @blur="amountBlur"
                  class="required"
                ></no-autocomplete-textfield> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="close">
            {{
            $t("globals.cancel")
            }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="saving"
            color="primary"
            @click="save"
          >{{ $t("globals.save") }}</v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
      :title="$t('views.planbalance.plan_balance')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="payment"
      v-if="selectedPlan!=null"
    >
      <pbas-data-table
        v-if="role.indexOf('Broker Plan Manager') > -1 || role.indexOf('Broker Plan Admin') > -1"
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="plan-balance"
        :canExpand="(item) => item.HasPaymentsHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item)=>generateProvider(item)"
        identifier="planBalanceTable"
        @itemsChanged="setData($event)"
        @error="error=$event"
      ></pbas-data-table>
      <pbas-data-table
        v-else-if="role.indexOf('Employer Plan Admin') > -1 || role.indexOf('Employer Members Viewer') > -1"
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="plan-balance"
        :canExpand="(item) => item.HasPaymentsHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item)=>generateProvider(item)"
        identifier="planBalanceTable"
        @itemsChanged="setData($event)"
        :showSelect="false"
        @error="error=$event"
      ></pbas-data-table>
      
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{$t(message)}}
        <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
      </v-snackbar>
      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import PlanBalanceHeaders from "../headers/PlanBalance";
import PlanBalanceStoresHeaders from "../headers/PlanBalanceStores";
import PlanBalanceHistoryHeaders from "../headers/PlanBalanceHistory";
import ErrorHandler from "../components/ErrorHandler";
import { locker } from "../mixins/locker";
import TransSelect2 from "../components/TransSelect2";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import CurrencyTextfield from '../components/CurrencyTextfield.vue';

export default {
  name: "plans-billing-table",
  components: {
    ErrorHandler,
    TransSelect2,
    NoAutocompleteTextfield,
    CurrencyTextfield
  },
  mixins: [locker, planSetter],
  data() {
    return {
      name: "",
      selected: [],
      billingTerms: [],
      saving: false,
      items: [],
      rowActions: [
        {
          name: "addPayment",
          icon: "add",
          title: this.$t("views.planbalance.add_payment"),
          handler: item => this.addPayment(item)
        }
      ],
      dialogs: {
        add: false
      },
      valid: true,
      error: null,
      provider: undefined,
      show: false,
      editedIndex: -1,
      payment: {},
      defaultPayment: {},
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: [],
      expandOdataHeaders: PlanBalanceHistoryHeaders
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { planIdentity: "planIdentity" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" })
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      }
    }
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("plansMembers", [
      "getBillingTerms",
      "newPayment2",
      "newPaymentStore",
      "getAsync",
      "lockAddPayment"
    ]),
    allowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    async loadPlanData() {
      this.headers = Object.assign([], PlanBalanceHeaders);
      if (!this.planParameters.TrackPerEmployer) {
        this.headers = PlanBalanceStoresHeaders;
      } else {
        this.headers = PlanBalanceHeaders;
      }
      let url = "plans/" + this.selectedPlan.Id + "/employers";
      if (!this.planParameters.TrackPerEmployer)
        url = "plans/" + this.selectedPlan.Id + "/stores";
      this.provider = new PbasOData(
        this.$axiosHttp,
        url,
        this.headers
      );
    },
    generateHistoryUrl(item) {
      let url =
        "plans/" +
        this.selectedPlan.Id +
        "/employers/" +
        item.Id +
        "/paymentsHistory";
      if (!this.planParameters.TrackPerEmployer) {
        url =
          "plans/" +
          this.selectedPlan.Id +
          "/stores/" +
          item.Id +
          "/paymentsHistory";
      }
      return url;
    },
    generateProvider(item) {
      const url = this.generateHistoryUrl(item);
      return new PbasOData(this.$axiosHttp, url, this.expandOdataHeaders);
    },
    async addPayment(item) {
      try {
        await this.lock(
          this.lockAddPayment,
          {
            id: item.Id,
            plan: this.selectedPlan.Id,
            dialogs: this.dialogs,
            dialog: "add"
          },
          () => {
            this.dialogs.add = false;
          }
        );

        this.billingTerms = (
          await this.getBillingTerms({
            plan: this.selectedPlan.Id
          })
        ).data.value;

        this.editedIndex = this.items.indexOf(item);
        this.name = item.Name;
        //console.log(item, this.items, this.editedIndex);
        this.payment = JSON.parse(JSON.stringify(this.defaultPayment));
        this.dialogs.add = true;
      } catch (error) {
        this.error = error;
      }
    },
    close() {
      this.dialogs.add = false;
      this.payment = JSON.parse(JSON.stringify(this.defaultPayment));
      this.editedIndex = -1;
      this.$refs.form.resetValidation();
      this.saving = false;
    },
    save() {
      //console.log(this.editedIndex, this.items);
      if (this.editedIndex > -1) {
        this.tryAddPayment();
      }
    },
    async tryAddPayment() {
      try {
        this.saving = true;
        let item = JSON.parse(JSON.stringify(this.payment));
        item.BillingTermId = item.BillingTerm.Id;
        delete item.BillingTerm;
        let amount = parseFloat(item.Amount);
        item.Amount = amount;
        if (!this.planParameters.TrackPerEmployer) {
          item.StoreId = this.items[this.editedIndex].Id;
          await this.newPaymentStore({
            plan: this.selectedPlan.Id,
            store: this.items[this.editedIndex].Id,
            payload: item
          });
        } else {
          item.EmployerId = this.items[this.editedIndex].Id;
          await this.newPayment2({
            plan: this.selectedPlan.Id,
            employer: this.items[this.editedIndex].Id,
            payload: item
          });
        }

        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.$refs.table.getDataAsync();
        this.close();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    // amountBlur(evt) {
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   if (!value) return;
    //   this.payment.Amount = parseFloat(value).toFixed(2);
    // },
    // isNumeric(evt) {
    //   var iKeyCode = evt.which ? evt.which : evt.keyCode;
    //   if (
    //     iKeyCode != 46 &&
    //     iKeyCode > 31 &&
    //     (iKeyCode < 48 || iKeyCode > 57) &&
    //     (iKeyCode < 96 || iKeyCode > 105)
    //   )
    //     return false;

    //   return true;
    // },
    // currencyKeyUp(evt) {
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   //console.log(JSON.stringify({ v: value }));
    //   if (!value) return;
    //   var start = el.selectionStart;
    //   var end = el.selectionEnd;
    //   el.value = parseFloat(value).toFixed(2);
    //   if (start === 0 && end === 0) {
    //     end = 1;
    //   }
    //   el.setSelectionRange(start, end);
    //   //console.log("UP: ", el.value, value, start, end);
    // },
    // currencyKeydown(evt, sender) {
    //   if (evt.keyCode == 8 || evt.keyCode == 46) {
    //     //console.log("delete");
    //     return;
    //   }
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   //console.log("V: ", value);
    //   if (!value) {
    //     if (evt.keyCode == 190 || evt.keyCode == 110) {
    //       el.value = value + "0.";
    //       el.setSelectionRange(2, 2);
    //     } else if (this.isNumeric(evt)) {
    //       el.value = value + ".00";
    //       el.setSelectionRange(0, 0);
    //     }
    //   } else if (parseFloat(value) && value.indexOf(".") == -1) {
    //     var start = el.selectionStart;
    //     el.value = value + ".00";
    //     el.setSelectionRange(start, start);
    //   }
    //   value = el.value;
    //   //console.log(value);
    //   if (
    //     (evt.keyCode == 190 || evt.keyCode == 110) &&
    //     value.indexOf(".") >= 0
    //   ) {
    //     el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
    //     evt.preventDefault();
    //     return;
    //   }
    //   //console.log(evt);

    //   if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
    //     evt.preventDefault();
    //   } else if (evt.keyCode === 13) {
    //     evt.preventDefault();
    //   }
    // },

    setData(items) {
      this.items = items;
    }
  }
};
</script>

<style>
.full-width {
  width: 100%;
}
</style>


